/**
 * Allows classes to implement interfaces with static properties
 *
 * @author Asbjørn Rysgaard Eriksen <are@caretaker.dk>
 * @typeParam T The interface the class should extent
 */
export function staticImplements<T>(): <U extends T>(constructor: U) => undefined {
    return () => undefined;
}
